export const widths = {
    outline: 0.5,
    data: 2.5,
    axis: 1.0,
    grid: 2.0
}

export const dashes = {
    grid: '2,2'
}
